export const absenceTypesListPathName = 'absence-types';
export const journalNoteContentTypeListPathName = 'journal-note-content-type';
export const planTypesListPathName = 'plan-types';
export const grantTypesListPathName = 'grant-types';
export const visitationTeamsListPathName = 'visitation-teams';
export const interviewTypesListPathName = 'interview-types';
export const methodTypesListPathName = 'method-types';

export const personGroupPathName = 'persongroups';
export const reasonForReadWriteMathTestPathName = 'reason-for-read-write-math-test';
export const observationTypesListPathName = 'observation-types';
